<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
            <h2 class="white--text">{{ $t('reset-password.texts.resale') }}</h2>
            <v-card class="elevation-2">
                <v-toolbar flat>
                    <v-toolbar-title>{{
                        $t('reset-password.texts.title')
                    }}</v-toolbar-title>
                </v-toolbar>

                <v-form
                    @submit.prevent="reset"
                    ref="form"
                    lazy-validation
                    v-if="!loading"
                >
                    <v-card-text>
                        <v-checkbox
                            v-for="(reseller, index) in resellers"
                            :key="index"
                            v-model="form.resellers"
                            :label="reseller"
                            :value="index"
                        ></v-checkbox>

                        <v-text-field
                            :label="$t('reset-password.labels.password')"
                            v-model="form.password"
                            prepend-icon="mdi-lock"
                            type="password"
                            autofocus
                        ></v-text-field>
                        <v-text-field
                            :label="
                                $t(
                                    'reset-password.labels.password_confirmation',
                                )
                            "
                            v-model="form.password_confirmation"
                            prepend-icon="mdi-lock"
                            type="password"
                            autofocus
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            class="light-blue accent-2"
                            dark
                            block
                            :loading="sending"
                            type="submit"
                            >{{ $t('reset-password.buttons.submit') }}</v-btn
                        >
                    </v-card-actions>
                </v-form>
                <template v-else>
                    <v-row justify="center" align="center">
                        <v-col class="text-center" xs="12" md="12">
                            <v-progress-circular
                                :size="50"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                </template>
            </v-card>
            <div class="mt-4 text-center">
                <v-btn small text dark :to="{ name: 'login' }">{{
                    $t('reset-password.buttons.login')
                }}</v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        token: String,
    },

    data: () => {
        return {
            form: {
                password: '',
                password_confirmation: '',
                token: '',
                resellers: [],
            },
            resellers: [],
            sending: false,
            loading: false,
        }
    },

    methods: {
        async getResetToken() {
            this.loading = true

            let res = null

            try {
                res = await this.$http.get('/auth/password/find/' + this.token)
            } finally {
                this.loading = false
            }

            if (!res) {
                this.$router.push({ name: 'ForgetPassword' })
            }

            if (typeof res.data.token != 'undefined') {
                this.form.token = res.data.token
            }

            if (typeof res.data.resellers != 'undefined') {
                this.resellers = res.data.resellers
            }
        },

        async reset() {
            this.sending = true

            let res = null

            try {
                res = await this.$http
                    .post('/auth/password/reset', this.form)
                    .catch(() => {
                        this.$bus.$emit(
                            'notify',
                            'error',
                            this.$t('reset-password.bus.request-error'),
                        )
                    })
            } finally {
                this.sending = false
            }

            if (!res) {
                return
            }

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('reset-password.bus.reset-password-success'),
            )

            this.$router.push({ name: 'login' })
        },
    },

    created() {
        this.getResetToken()
    },
}
</script>
